export default __webpack_public_path__ + "static/media/powerball_policy_v2.5113ea56.png";